import React, { useEffect, useState } from "react";

//import Snackbar from "@mui/material/Snackbar";

import Chart from "./Chart";
import DataFiltering from "./DataFiltering";
import RawScores from "./RawScores";
import { modelFetchUrl } from "./Url";
import { buildHomeModelData, homeScoresData } from "./JsonData";

const UkModel = props => {
  /* set state */
  const [allDates, setAllDates] = useState([]);
  const [modelData, setModelData] = useState([]);
  const [startDate, setStartDate] = useState(
    new Date(Date.now() - 2592000000).toISOString().substring(0, 10)
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().substring(0, 10)
  );
  const [resolution, setResolution] = useState("day");
  const [smoothing, setSmoothing] = useState(0);
  const [permaLink, setPermaLink] = useState(window.location.href);
  const [errorMessages, setErrorMessages] = useState([]);

  /* fetch data from api */
  useEffect(() => {
    const fetchUrl = modelFetchUrl(window.location.search, 'uk');
    fetch(fetchUrl)
      .then(response => {
        if (!response.ok) {
          throw Error("Cannot fetch scores from API");
        }
        return response.json();
      })
      .then(jsondata => {
        const homeModelData = buildHomeModelData(jsondata);
        setStartDate(homeModelData.startDate);
        setEndDate(homeModelData.endDate);
        setAllDates(homeModelData.allDates);
        setModelData(homeModelData.modelData);
      })
      .catch(error => {
        setErrorMessages([error.message]);
      });
  }, []);

  const handleUpdateModelData = updateData => {
    const updatedModelData = homeScoresData(updateData);
    setModelData(updatedModelData.modelData);
    setAllDates(updatedModelData.allDates);
  };

  const handlePropsChange = event => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    if (value !== undefined) {
      switch (name) {
        case "startDate":
          setStartDate(value);
          break;
        case "endDate":
          setEndDate(value);
          break;
        case "resolution":
          setResolution(value);
          break;
        case "smoothing":
          setSmoothing(value);
          break;
        default:
          console.log("Prop not implemented");
      }
    }
  };

  const handleUpdatePermalink = plinkUrl => {
    setPermaLink(plinkUrl);
  };

  const handleErrorCallback = message => {
    setErrorMessages(message);
  };

  return (
    <React.Fragment>
      <Chart
        charttitle="Estimated COVID-19 prevalence score using Google search data for the UK"
        modeldata={modelData}
        permalink={permaLink}
      />
      {
        false && (
          <DataFiltering
            modelIds={modelData.map(m => m.id)}
            startDate={startDate}
            endDate={endDate}
            resolution={resolution}
            smoothing={smoothing}
            updateCallback={handleUpdateModelData}
            onChangeCallback={handlePropsChange}
            permalinkCallback={handleUpdatePermalink}
            errorCallback={handleErrorCallback}
          />
        )
      }
      <RawScores
        geo="uk"
        modeldata={modelData}
        allDates={allDates}
      />
      {errorMessages.forEach(message => (
        console.log(message)
      ))}
    </React.Fragment>
  );
};

export default UkModel;
